module.exports = __webpack_public_path__ + "assets/img/16.bcdd9857.png";